<template>
  <div id="app" class="font-sans flex flex-col p-4">
    <bio v-if="!loggedIn" :text="text" class="flex-auto" />
    <bio-admin v-else class="flex-auto" />
    <footer class="flex-initial text-xs text-gray pt-10 sm:px-4 md:px-8">
      <login v-if="loggingIn" v-on-clickaway="loginAway" :loggedIn="loggedIn" />
      <div class="inline-block w-16">
        <button class="my-1" @click.prevent="loginClick">
          {{ loginText }}
        </button>
      </div>
      <span class="inline-block my-1">website by tyler madsen</span>
    </footer>
  </div>
</template>

<script>
import store from 'store'
import { mixin as clickaway } from 'vue-clickaway'
import Bio from './components/Bio.vue'
import BioAdmin from './components/admin/Bio.vue'
import Login from './components/Login.vue'
import query from '@/graphql/queries/bio.gql'
import stripTypenames from '@/util/strip-typenames'
import { ADMIN_TOKEN_KEY } from 'spencer'

export default {
  name: 'App',

  mixins: [clickaway],

  components: {
    Bio,
    BioAdmin,
    Login
  },

  apollo: {
    text: {
      query,
      update({ bio }) {
        if (!bio) {
          bio = {}
        }
        bio = stripTypenames(bio)
        if (!bio.text || !(bio.text instanceof Array)) {
          bio.text = []
        }
        return bio.text
      }
    }
  },

  data: () => ({
    text: [],
    loggingIn: false,
    loggedIn: store.get(ADMIN_TOKEN_KEY)
  }),

  computed: {
    loginText() {
      if (this.loggedIn) {
        return 'log out'
      }
      return this.loggingIn ? 'hide' : 'login'
    }
  },

  mounted() {
    this.$bus.$on('login', this.login)
  },

  methods: {
    toggleLogin() {
      this.loggingIn = !this.loggingIn
    },

    login(token) {
      store.set(ADMIN_TOKEN_KEY, token)
      this.loggedIn = token
      if (token) {
        this.loggingIn = false
      }
    },

    loginClick() {
      store.set(ADMIN_TOKEN_KEY, null)
      if (this.loggedIn) {
        this.login(null)
      } else {
        this.toggleLogin()
      }
    },

    loginAway() {
      if (this.loggingIn) {
        this.loggingIn = false
      }
    }
  }
}
</script>

<style>
@import './assets/css/reset.css';

@font-face {
  font-family: 'Adobe Blank';
  src: url('./assets/fonts/AdobeBlank.eot');
  src: url('./assets/fonts/AdobeBlank.woff') format('woff'),
    url('./assets/fonts/AdobeBlank.ttf') format('truetype');
}

@tailwind components;
@tailwind utilities;

html,
body {
  height: 100%;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100%;
}
</style>
